import { createFileRoute, redirect } from '@tanstack/react-router';
import { validateDiagnosisSearch } from '../diagnosis/$uuid';

/**
 * The CadMorph library is the Diagnosis library now (ENG-2742). A hand-off
 * that names a geometry opens its workspace, carrying the study context and
 * the conversation.
 */
export const Route = createFileRoute('/_app/cadmorph/')({
  validateSearch: validateDiagnosisSearch,
  beforeLoad: ({ search: { geometry, ...rest } }) => {
    if (geometry) {
      throw redirect({
        to: '/diagnosis/$uuid',
        params: { uuid: geometry },
        search: rest,
        replace: true,
      });
    }
    throw redirect({ to: '/diagnosis', replace: true });
  },
});
